import React from "react";
import { Container } from "react-bootstrap";

const AboutSection = () => {
  return (
    <section
      id="about"
      style={{
        backgroundColor: "#f7f7f7",
        overflow: "hidden",
        minHeight: "100vh",
      }}
      className=" about d-flex justify-content-start align-items-center flex-column"
    >
      <div
        style={{
          backgroundColor: "rgb(15, 12, 31)",
          padding: "20px",
          width: "100%",
          color: "#fff",
          marginBottom: "5rem",
        }}
      >
        <h3 className="mb-2 text-center">About Me</h3>
        <p className="text-center">
          Get to know me, I might be what you are looking for.
        </p>
      </div>
      <Container>
        <div>
          <p>
            Hi&#128512;! My name is Isaiah Tadiwanashe Chiraira. I am an
            exceptionally organized, resourceful, and highly motivated final
            year student, studying towards BSc in Engineering (Electrical)
            Information. I am a firm believer in skills over grades. This has
            led me into developing a robust and diverse skill set ranging from
            software, hardware to as far as finance. I am very passionate about
            solving problems in the most efficient way. I am not much concerned
            with whether the solution works but with how well it works. This is
            true for all the software solutions I design and all hardware I fix.
          </p>
        </div>
        <div>
          I was involved in a lot of software projects both school and
          individual projects, and this has taken my programming skills to
          another level. The projects range from simple text-based games to
          complex deep learning projects as well as embedded systems. I have
          collaborated with other developers in some of the projects and this
          has made me a better team player. I have also learned and mastered
          Agile and SCRUM from these collaborations.
        </div>
        <br />
        <div>
          <p>
            During my spare time, I fix broken electronic gadgets, including
            phones, laptops, and also gaming consoles. I also believe in passing
            knowledge to others, and therefore I started a tutoring group called
            Fortune500 Tutors. Growing up, I was always inspired by Fortune 500
            CEOs and wanted to be one. I then realized that before I can become
            a Fortune 500 CEO, I should be a Fortune 500 material in everything
            I do. I tutor in such a way that if the Fortune magazine was to list
            the top 500 tutors across the globe, I would make up the list. The
            tutoring journey has been the most satisfying journey. Nothing beats
            the feeling of having people telling you that "because of you, I
            will graduate".
            <br />
            <br />
            I have learned the importance of financial independence, hence I
            have developed a business mind. I have learned the art of selling (I
            can even sell sand to the Arabs, &#128517;). I also know about
            stocks, commodities, and forex trading.
            <br />
            <br />
          </p>
        </div>

        <div className="row">
          <div className="col-lg-4" id="pic">
            <img src="/images/profile-img.jpeg" className="img-fluid" alt="" />
            <img
              src={process.env.PUBLIC_URL + "/profile-img.jpeg"}
              alt=""
              className="img-fluid "
            />
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content">
            <h3>Information Engineer &amp; Software Developer.</h3>
            <p className="fst-italic">
              More about my personal information is presented below.
            </p>
            <div className="row">
              <div className="col-lg-5">
                <ul>
                  <li>
                    <i className="bi bi-gift"></i> <strong>Birthday:</strong>{" "}
                    <span>31 May 1999</span>
                  </li>
                  <li>
                    <i className="bi bi-gender-male"></i>{" "}
                    <strong>Gender:</strong> <span>Male</span>
                  </li>
                  <li>
                    <i className="bi bi-telephone"></i> <strong>Phone:</strong>{" "}
                    <span>+27 788 258 790</span>
                  </li>
                  <li>
                    <i className="bi bi-geo-alt"></i> <strong>City:</strong>{" "}
                    <span>Johannesburg, SA</span>
                  </li>
                  <li>
                    <i className="bi bi-controller"></i>{" "}
                    <strong>Hobbies:</strong> <span>Skating, Soccer</span>
                  </li>
                </ul>
              </div>
              <div className="col-lg-7">
                <ul>
                  <li>
                    <i className="bi bi-calendar-event"></i>{" "}
                    <strong>Age:</strong> <span>24</span>
                  </li>
                  <li>
                    <i className="bi bi-mortarboard"></i>{" "}
                    <strong>Degree:</strong>{" "}
                    <span>BSc Eng (Electrical) Info</span>
                  </li>
                  <li>
                    <i className="bi bi-bank"></i> <strong>University:</strong>{" "}
                    <span>Witwatersrand</span>
                  </li>
                  <li>
                    <i className="bi bi-envelope"></i> <strong>Email:</strong>{" "}
                    <span>itchiraira@gmail.com</span>
                  </li>
                  <li>
                    <i className="bi bi-person-workspace"></i>{" "}
                    <strong>Freelance:</strong> <span>Available</span>
                  </li>
                </ul>
              </div>
            </div>
            <p></p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AboutSection;
